import { render, staticRenderFns } from "./DurationToggle.vue?vue&type=template&id=2ca6ddda&"
import script from "./DurationToggle.vue?vue&type=script&lang=js&"
export * from "./DurationToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports